module.exports = __webpack_public_path__ + "img/好友列表小三角.31fdac5e.png";